const NZ_REDIRECT_URL = 'https://quierosumarme.psimammoliti.com/?yaconfigurohorarios=true';

export function redirectToN0Url(): void {
  window.location.href = NZ_REDIRECT_URL;
}
